export default {
  header: {
    title: 'Belønninger',
  },
  content: {
    title: 'Du har {{balance}} point',
    description: 'Brug {{amount}}, få {{rewards}} point! Læg gratis varer i kurven med dine optjente point.',
    articles: {
      title: 'Optjen point med hver ordre',
      spend_description: 'Hver {{amount}}, du bruger, giver {{rewards}} point på din konto.',
      redeem_title: 'Løs dine point ind',
      redeem_description:
        'Indløs dine point til gratis godbidder! Begynd at optjene belønninger ved {{minSpendingLimit}} point, svarende til {{amount}} brugt',
      discounts_title: 'Opdag eksklusive fordele',
      discounts_description: 'Lås op for eksklusive tilbud og rabatter.',
    },
  },
};
